<template>
	<div class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="main-content">
					<div class="card">
						<div class="card-header d-flex justify-content-between">
              <h5>Account Notes</h5>
              <button type="button" @click="openNotesModal" class="btn btn-primary btn-sm pull-right">
                Add New Note
              </button>
						</div>
						<div class="card-body">
              <account-notes v-if="!notesLoader && sortedAccountNotes.length" :accountNotes="sortedAccountNotes" :docId="docID"/>
              <div class="loader" v-else-if="notesLoader">
              </div>
              <div v-else class="text-center">
                No Notes Available!
              </div>
						</div>
					</div>
				</div>
			</div>
		</div>
    <div class="row">
      <div class="col-md-12">
        <div class="main-content">
          <div class="card">
            <div class="card-header d-flex align-items-center justify-content-between">
              <h5>Manual Tasks</h5>
              <div class="text-right mr-20 d-flex align-items-center">
                <input v-model="searchQuery" type="text" class="form-control mr-5" style="height: 30px;" placeholder="Search..." />
                <div class="dropdown">
                  <button style="width: 20px!important; padding: 0!important;" title="Filter by Tags" class="filter-btn btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fa fa-filter fs-20 mt-2"></i>
                  </button>
                  <div style="min-width: 7rem;" class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownMenuButton2">
                    <div v-for="(option, index) in filterOptions" :key="index">
                      <div class="ml-10 mt-3 d-flex align-items-center" >
                        <input  @input="addFilter($event)" type="checkbox" v-model="selectedFilters"  :value=option>
                        <span class="text-capitalize sml-10 ml-5">{{ option }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="card-body">
              <TaskNotes @refresh="getAllTasks" v-if="!taskLoader && sortedActiveResolvedNotes.length" :accountNotes="sortedActiveResolvedNotes" :docId="docID"/>
              <div class="loader" v-else-if="taskLoader">
              </div>
              <div v-else class="text-center">
                No Tasks Available!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
		<div class="row">
			<div class="col-md-12">
				<Alert :type="alertType" :message="alertMessage" v-if="alertShow === true"/>
				<div class="card" v-if="asyncDone === false">
					<!-- Show the loader when async operation is going on -->
					<div class="loader"></div>
					<h4 class="text-center">{{asyncText}}</h4>
				</div>
				<div class="main-content">
					<div class="card" v-if="fetchedDetails === true && asyncDone === true">
						<div class="card-header">
              <h4 class="card-title text-center">Edit the User Details </h4>
              <div class="row">
                <div class="col-md-2 mr-0 pr-0 d-flex align-items-center">
                   <span class="lh-3 pull-left">
                    <b>Total Services:</b><span style="background-color: #51BCDA" title="Total Reviews" class="badge noti-icon-badge ml-5">{{ totalServices }}</span>
                    <b class="ml-8">Total Sites:</b> <span style="background-color: orange" title="Total Reviews" class="badge noti-icon-badge ml-5">{{ totalSites }}</span>
                  </span>
                </div>
                <div class="col-md-8 pl-0 text-center">
                  <h5 class="card-title"><a :href="'https://portal.bigscoots.com/admin/?cmd=clients&action=show&id='+customerInfo.id" target="_blank">{{ customerInfo.id }}</a> - {{customerInfo.firstName + ' ' + customerInfo.lastName}} - {{customerInfo.email}} </h5>
                </div>
              </div>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-md-3">
                  <div class="d-flex align-items-center">
                  <label class="mr-2" for="refresh">Show Refresh Banner: </label>
                  <switch-control v-model="refreshFlag" id="refresh" @change="refreshPage"/>
                  </div>
                  <div class="d-flex align-items-center">
                  <label class=" mr-2" for="watchList">Watch Client:</label>
                  <switch-control v-model="watchClientStatus" id="refresh" @change="changeWatchClientStatus"/>
                  </div>
                </div>
								<div class="col-md-1" v-if="allowedEmails.includes(user.email)">
                  <button type="button" class="btn text-light btn-link bg-primary btn-sm" @click="loginAsUser(docID)">
                    <div v-if="gotoNuxtLoader" class="loader small_loader" style="width: 17px;height: 17px; margin: 0 auto !important;"></div>
                    <span v-else>Visit User</span>
                  </button>
								</div>
								<div class="col-md-6">
									<!-- color-classes: "nav-pills-primary", "nav-pills-info", "nav-pills-success", "nav-pills-warning","nav-pills-danger" -->
									<ul class="nav nav-pills nav-pills-primary nav-pills-icons justify-content-center mb-2" role="tablist">
										<li class="nav-item">
											<a class="nav-link active" data-toggle="tab" href="#hostingInfoEdit" role="tablist">
												Account Details
											</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" data-toggle="tab" href="#basicDetailsEdit" role="tablist">
												Basic Details
											</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" data-toggle="tab" href="#emailAndPasswordEdit" role="tablist">
												Email &amp; Password
											</a>
										</li>
									</ul>
								</div>

								<div class="col-md-3">
									<div class="login-as-user">
										<button type="button" class="btn text-light btn-link bg-primary btn-sm pull-right" @click="goToNuxt(docID)">
                      <div v-if="gotoNuxtLoader" class="loader small_loader" style="width: 17px;height: 17px; margin: 0 auto !important;"></div>
                      <i v-else class="fa fa-user"></i>
										</button>
									</div>
									<div class="refresh-storage">
										<button type="button" class="btn text-light btn-link bg-primary btn-sm pull-right" @click="refreshStorage()">
											<i :class="{'fa fa-hdd-o': true, 'fa-spin': spinner}"></i>
										</button>
									</div>
                    <div>
                      <div class="dropdown pull-right">
                            <button class="btn btn-primary btn-sm" :class="{'dropdown-toggle': !dropdownLoader}" :disabled="dropdownLoader" type="button" id="dropdowngeneralButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <div v-if="dropdownLoader" class="loader small_loader" style="width: 17px;height: 17px; margin: 0 auto !important;"></div>
                                <span v-else>Choose Operation</span>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <a class="dropdown-item" href="javascript:void(0)" @click.prevent="loadActivateSiteModal()">Bulk Activate Sites</a>
                                <a class="dropdown-item" v-if="emailSetup" href="javascript:void(0)" @click="terminateEmailService">Terminate Email Service</a>
                                <a class="dropdown-item" v-else href="javascript:void(0)" @click="getHostingAccounts(docID)">Setup New Email Service</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click="resetBackupTime">Refresh Backup Time</a>
                              <a class="dropdown-item" href="javascript:void(0)" @click="syncSiteUuids">Sync Site Uuids</a>
                              <a class="dropdown-item" :class="processingDomainList.length!==0 ? 'disabled' : '' "  href="javascript:void(0)" @click="openHostBillComponent">Fetch Accounts</a>
                                <a class="dropdown-item" :class="processingDomainList.length!==0 ? 'disabled' : '' "  href="javascript:void(0)" @click="openFetchDomainsComponent">Fetch Domains</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click="runAutoSSL">Run Auto SSL</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click.prevent="updateSearchIndex()">Update Search Index</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click.prevent="syncTicketAccess()">Sync Ticket Access</a>
<!--                                <a class="dropdown-item" href="javascript:void(0)" @click="openOveragesModal">Review Overages</a>-->
                            </div>
                        </div>
                    </div>
								</div>
							</div>


							<div class="tab-content tab-space tab-subcategories">
								<!-- Panel for Hosting Account Details Edit - START -->
								<div class="tab-pane active" id="hostingInfoEdit">
                  <div class="loader" v-if="hostingLoading"></div>
									<HostingDetailsUpdate v-show="!hostingLoading" @loadActivateCfModal="loadActivateCfModal" @updateCounts="updateCounts" :processingDomainList="processingDomainList" @updateIP="updateIP" />
								</div>
								<!-- Panel for Hosting Account Details Edit - END -->
								<!-- Panel for the Basic User Details Edit - START -->
								<div class="tab-pane" id="basicDetailsEdit">
									<BasicUserDetailsUpdate/>
								</div>
								<!-- Panel for the Basic User Details Edit - END -->
								<!-- Panel for the Email & Password Edit - START -->
								<div class="tab-pane" id="emailAndPasswordEdit">
									<EmailUpdate/>
									<hr>
									<PasswordUpdate/>
                  <hr v-if="customerInfo.twoFA && !FAChanged">
                  <form v-if="customerInfo.twoFA && !FAChanged" class="form-horizontal" @submit.prevent="removeTwoFA">
                    <div class="row">
                      <label class="col-sm-2 col-form-label">Remove Two FA
                      </label>
                      <div class="col-sm-4">
                        <button :disabled="disable2FA" class="btn btn-danger mt-0 text-white">Disable Two Factor Authentication </button>
                      </div>
                    </div>
                  </form>
								</div>
								<!-- Panel for the Email & Password Edit - END -->
							</div>
						</div>
					</div>
					<!-- Card that holds the custoer details update section in sub-categorized design - END -->
				</div>
				<FetchHostBillAccounts ref="fetchHostBillComp" />
				<FetchDomains :syncUuids="syncSiteUuids" ref="fetchDomains" />
        <fetch-overages ref="fetchOverages" />
        <domain-notes :docID="docID" ref="notes" />
        <move-plan-modal ref="planModal" />
        <sync-ticket-access :docID="docID" ref="syncTicketAccess" />
        <subsite-modal ref="subsiteModal" :docID="docID" />
        <activate-c-f-modal ref="activeCfModal"/>
        <bulk-activate-site-modal ref="bulkActivateSiteModal"/>
        <add-tag-modal ref="tagModal" :docID="docID" />
			</div>
		</div>
	</div>
</template>

<script>
	import {db} from "@/firebase/init";
	import refreshToken from "../../../mixins/refreshTokenMixin";
	import loginAsMixin from "../../../mixins/loginAsMixin";
  import swal from 'sweetalert2';
	import _ from 'lodash';
	import emailSetupMixin from "../../../mixins/emailSetupMixin";
  import movePlanModal from "@/components/Admin/EditUser/HostingDetailsUpdate/movePlanModal";
  import TaskNotes from "@/components/Admin/EditUser/TaskNotes/TaskNotes.vue";
  import { v4 as uuidv4 } from 'uuid';
  import CollaboratorList from "@/components/Admin/EditUser/Collaborators/CollaboratorList.vue";
  import HostingAccountLogMixin from "@/mixins/hostingAccountLogMixin";
  import subsiteModal from "@/components/Admin/EditUser/HostingDetailsUpdate/subsiteModal.vue";
  import ActivateCFModal from "@/components/Admin/Tasks/activateCFModal.vue";
  import BulkActivateSiteModal from "@/components/Admin/EditUser/HostingDetailsUpdate/bulkActivateSiteModal.vue";
  import SwitchControl from "@/components/inputs/SwitchControl.vue";
  import {isMultiDocUser, getOrderedHostingDocs, getOrderedDomainDocs} from '@/utils/firestoreUtils';
  import addTagModal from "@/components/Admin/EditUser/HostingDetailsUpdate/addTagModal";

export default {
		name: "EditUser",
		mixins: [refreshToken, loginAsMixin, emailSetupMixin,HostingAccountLogMixin],
		components: {
      BulkActivateSiteModal,
      addTagModal,
      SwitchControl,
      ActivateCFModal,
      movePlanModal,
      TaskNotes,
      CollaboratorList,
      subsiteModal,
			Alert: () =>
				import(/* webpackChunkName: "alert" */ "../../../components/Alerts.vue"),
			BasicUserDetailsUpdate: () =>
				import(/* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/EditUser/BasicDetailsUpdate/BasicDetailsUpdate.vue"),
			EmailUpdate: () =>
				import(/* webpackChunkName: "emailUpdate" */ "../../../components/Admin/EditUser/EmailUpdate/EmailUpdate.vue"),
			PasswordUpdate: () =>
				import(/* webpackChunkName: "passwordUpdate" */ "../../../components/Admin/EditUser/PasswordUpdate/PasswordUpdate.vue"),
			HostingDetailsUpdate: () =>
				import(/* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/EditUser/HostingDetailsUpdate/newHostingDetailsUpdate"),
      AccountNotes: () =>
          import(/* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/EditUser/AccountNotes/list"),
      domainNotes: () =>
				import(/* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/EditUser/HostingDetailsUpdate/domain-notes"),
			FetchHostBillAccounts: () =>
					import(/* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/EditUser/AddNewPlan/FetchAndAddFromHostBill.vue"),
      FetchDomains: () =>
					import(/* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/EditUser/FetchDomains/fetchDomainModal.vue"),
      FetchOverages: () =>
					import(/* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/EditUser/Overages/fetchOverages"),
      syncTicketAccess: () =>
					import(/* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/EditUser/HostingDetailsUpdate/syncTicketAccessModal.vue")
		},
		props: {
			docID: String
		},
    mounted () {
      this.getAllAccountNotes()
      this.getAllTasks()
      this.getWatchClientStatus()
    },
		data() {
			return {
        showItUID: 'KHLq1RjrpMT7aV0JY9fy2yrcYvT2',
			  ip: null,
        customer: {
					id: null
				},
        syncSiteIds: false,
        searchQuery: '',
        allowedEmails: ['hamza.javaid@septemsystems.com', 'salman.yousaf@septemsystems.com', 'raohamzajavaid42@gmail.com'],
				spinner: false,
				fetchedDetails: false,
        hostingLoading: false,
				emailSetup:false,
				disableTerminateBtn:false,
				accountListener: null,
        dupAccountListener: null,
				counterListener: null,
        processingDomainList: [],
        pendingJobListener : null,
				runningSSL: false,
				resetBackup: false,
        jobCounter: 0,
        loading: false,
        taskLoader: false,
        notesLoader: false,
        refreshFlag: false,
        watchClientStatus: false,
        another: true,
        accountNotes: [],
        taskNotes: [],
        disable2FA: false,
        adminWatchList: [],
        watchList: [],
        FAChanged: false,
        totalServices: 0,
        totalSites: 0,
        resolvedTasks:[],
        activeTasks: [],
        hostingDocListeners: [],
        selectedFilters: ['all','active', 'resolved' ],
        filterOptions: ['active', 'resolved', 'all'],
			};
    },
		watch: {
			docID(newId) {
        this.$store.commit('hosting/setDocID', newId)
        this.getAllAccountNotes()
        this.getAllTasks()
				this.attachDetachListener(newId);
			},
      customerInfo: {
        immediate: true,
        deep: true,
         handler(value) {
          this.refreshFlag=value.refreshFlag
           const watchStatus= this.watchList.findIndex((value)=>value.uid === value.docID);
           // this.watchClientStatus= watchStatus !== -1
        }
      }
		},
		computed: {
      sortedAccountNotes () {
        return this.accountNotes.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
      },
      sortedTaskNotes () {
        return this.sortedActiveResolvedNotes.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
      },
      sortedActiveResolvedNotes () {
        console.log(this.selectedFilters, 'filter')
        if (this.selectedFilters.includes('all') || this.selectedFilters.length === 0) {
          let allTasks = this.activeTasks.concat(this.resolvedTasks)
          if(this.searchQuery) {
            allTasks = allTasks.filter(el => {
              if(el.domain && el.domain.toLowerCase().includes(this.searchQuery)) {
                return true;
              } else if(el.hostBillID && el.hostBillID.includes(this.searchQuery)) {
                return true
              }
              return false;
            })
          }
          return allTasks;
        }

        const activeTasks = this.selectedFilters.includes('active')
            ? this.activeTasks
            : [];

        const resolvedTasks = this.selectedFilters.includes('resolved')
            ? this.resolvedTasks
            : [];

        let allTasks = activeTasks.concat(resolvedTasks);
        if(this.searchQuery) {
          allTasks = allTasks.filter(el => {
            if(el.domain && el.domain.toLowerCase().includes(this.searchQuery)) {
              return true;
            } else if(el.hostBillID && el.hostBillID.includes(this.searchQuery)) {
              return true
            }
            return false;
          })
        }
        return allTasks;
      },
      customerInfo () {
        return this.$store.getters["customer/details"];
      },
      dropdownLoader () {
        return this.resetBackup || this.runningSSL || this.disableTerminateBtn || this.syncSiteIds
      },
			asyncDone() {
				return this.$store.getters["async/state"];
			},
			alertType() {
				return this.$store.getters["alert/type"];
			},
			alertMessage() {
				return this.$store.getters["alert/message"];
			},
			alertShow() {
				return this.$store.getters["alert/show"];
			},
			asyncText() {
				return this.$store.getters["async/text"];
			},
    user() {
      return this.$store.getters.user;
    }
		},
    methods: {
      loadActivateCfModal(data) {
        console.log('data')
        this.$refs.activeCfModal.load(data)
      },
      addFilter(event){
        const { value } = event.target;
        if (value === 'all') {
         this.selectedFilters = ['active', 'resolved', 'all']
        }
        else{
          const index = this.selectedFilters.findIndex(el => el === 'all' )
          if (index !== -1) {
            this.selectedFilters.splice(index, 1)
          }
        }
      },
      async getWatchClientStatus(customerId){
        try{
          const ref = await db.collection('users').doc(this.user.uid).get();
          if(!ref.exists){
            throw new Error('User not found')
          }
          const user = ref.data();
          const {watchList}= user;
          this.watchList = watchList || [];
          const watchStatus =  this.watchList.find((value)=>value.uid === this.customerInfo.docID);
          console.log('watch status',this.watchList, watchStatus)
          this.watchClientStatus= !!watchStatus;
          console.log(this.watchClientStatus, 'watch status')
        }
        catch(e){
        console.log(e)
        }
      },
      async getTestAdmin(){
        const admins= [];
        const ref= await db.collection('users')
            .where('userWatchList', 'array-contains' , this.customerInfo.docID)
            .where('userType', '==', 'admin').get();
       if(!ref.empty){
         ref.forEach((value)=>{
         admins.push(value.data())
         })
       }
       console.log(admins)
      },
      async changeWatchClientStatus(){
        try{
          console.log('I was called here')
          this.watchClientStatus = !this.watchClientStatus;
          if(this.watchClientStatus){
            this.watchList.push({
              uid: this.customerInfo.docID,
              firstName: this.customerInfo.firstName,
              lastName: this.customerInfo.lastName,
              email: this.customerInfo.email,
            })
            await db.collection('users').doc(this.user.uid).update({
              watchList: this.watchList,
            });
            swal('Success', 'You hav successfully enabled watching client!', 'success');
          }
          else{
            this.watchList = this.watchList.filter(value=> value.uid !== this.customerInfo.docID);
            await db.collection('users').doc(this.user.uid).update({
              watchList: this.watchList
            });
            swal('Success', 'You hav successfully disabled watching client!', 'success');
          }
        }
        catch(e){
          console.log(e.message)
        }
      },
      async removeTwoFA () {
        try {
          const resp = await swal({
            title: "Are you sure?",
            text: 'Please confirm that you want to remove two factor authentication for this customer!',
            type: "question",
            confirmButtonText: "Yes Proceed",
            confirmButtonColor: "#6ACF98",
            showCancelButton: true,
            cancelButtonText: "No Thanks",
            cancelButtonColor: "#EE8057"
          })
          if (resp.value) {
            console.log(this.customerInfo)
            this.disable2FA = true;
            this.FAChanged = false;
            await db.collection('users').doc(this.customerInfo.docID).update({
              twoFAMethods: '',
              twoFA: false,
              twoFASecret: '',
              twoFAVerified: false
            });
            this.FAChanged = true;
            // await this.$store.dispatch('customer/fetchUser');
            swal('Success', 'Two Factor Authentication has been successfully removed for the client!', 'success')
          }
        } catch (e) {
          this.FAChanged = false;
          swal('Error', 'Something went wrong while disabling two factor authentication!', 'error')
        } finally {
          this.disable2FA = false;
        }
      },
      async getAllAccountNotes () {
        try {
          this.notesLoader = true;
          this.accountNotes = [];
          const ref= await db.collection('accountNotes').doc(this.docID).get();
          if(ref.exists) {
            const { notes } = ref.data();
            this.accountNotes = notes;
          }
          console.log('all notes', this.accountNotes)
        } catch (e) {
          console.log(e.toString());
        } finally {
          this.notesLoader = false;
        }
      },
      async getAllTasks(){
        try {
          this.taskLoader= true;
          this.taskNotes = [];
          this.activeTasks = [];
          this.resolvedTasks = []
          console.log('inside ', this.customerInfo.id)
          const ref= await db.collection('manualTasks').where('clientId' ,'==' , this.customerInfo.id).orderBy('createdAt', 'desc').get();
          console.log('size', ref.size)
          if(ref.size) {
            ref.forEach(el => {
              if(el.data().resolved){
              this.resolvedTasks.push({id: el.id, ...el.data()})
              }
              else{
                this.activeTasks.push({id: el.id, ...el.data()})
              }
              this.taskNotes.push({id: el.id, ...el.data()})
            })
          }
        } catch (e) {
          console.log(e.toString());
        } finally {
          this.loading = false;
          this.taskLoader = '';
        }
      },
      openNotesModal () {
        this.$refs.notes.load();
      },
      async syncTicketAccess() {
        const ref = await db.collection('users').doc(this.docID).get();
        let collaborators = [];
        if(ref.exists) {
          collaborators = ref.data().collaborators
        }
        this.$refs.syncTicketAccess.load(ref.data());
      },
      updateSearchIndex () {
        this.dropdownLoader = true;
        this.$http.post('/typesense/reinitialize-user-all-record', {
          grant_type: 'token',
          uid : this.docID,
        }).then(() => {
          swal('SUCCESS!', 'Search indexes have been updated for this account', "success");
          this.addLog({
            primaryPlan: 'Account Based Operation',
            uid: this.docID,
            message: 'User has Updated Search Index for all accounts!',
            level: "info"
          });
        }).catch(e => {
          swal('ERROR!', 'Error in updating search indexes', "error");
          this.addLog({
            uid: this.docID,
            message: 'Error in updating Search indexes!',
            level: "error"
          });
        }).finally(() => {
          this.dropdownLoader = false;
        })
      },
      async refreshPage(){
        this.refreshFlag= !this.refreshFlag
        await db.collection('users').doc(this.docID).update({refreshFlag: this.refreshFlag})
      },
		  updateIP(val){
		    this.ip=val
      },
      updateCounts(data) {
        this.totalServices = data.totalServices;
        this.totalSites = data.totalSites;
      },
			resetBackupTime(){
				this.resetBackup = true;
				this.$http.post('/backup/reset-download-time', {
					grant_type: 'token',
					UID: this.docID
				}).then(resp => {
          this.addLog({
            primaryPlan: 'Account Based Operation',
            message: resp.data.msg,
            level: 'success'
          })
					swal('Reset!', resp.data.msg, 'success');
				}).catch(e => {
					console.error(e);
          this.addLog({
            message: 'Something went wrong while refreshing backup time',
            level: 'danger'
          })
					swal('Error!', 'some thing went wrong!', 'error');
				}).finally(() => {
					this.resetBackup = false;
				})
			},
			openPopUp(){
				this.emailSetup = true
			},
			openHostBillComponent(){
				this.$refs.fetchHostBillComp.load();
			},
      openFetchDomainsComponent(){
				this.$refs.fetchDomains.load();
			},
      openOveragesModal () {
        this.$refs.fetchOverages.load();
      },
      async syncSiteUuids() {
        this.syncSiteIds = true;

        try {
          const allDomainDocs = await getOrderedDomainDocs(this.docID);
          if (!allDomainDocs.length) {
            swal('Error', 'No domains found for this UID.', 'error');
            return;
          }

          const allDomains = allDomainDocs.map(doc => ({ id: doc.id, ...doc.data() }));

          const hostingDocRefs = await getOrderedHostingDocs(this.docID);

          for (const docRef of hostingDocRefs) {
            const docSnap = await docRef.get();
            if (!docSnap.exists) continue;

            const { accounts } = docSnap.data();
            let hasChanges = false;

            for (const account of accounts) {
              const primaryDomainObj = allDomains.find(d => d.domain === account.primary.domain);
              if (primaryDomainObj) {
                if (primaryDomainObj.uuid) {
                  account.primary.uuid = primaryDomainObj.uuid;
                } else {
                  const uuid = uuidv4();
                  account.primary.uuid = uuid;
                  hasChanges = true;
                  await db.collection('domains').doc(primaryDomainObj.id).update({
                    uuid,
                    updatedAt: new Date().toISOString()
                  });
                }
              }

              for (const addon of account.addon) {
                const addonDomainObj = allDomains.find(d => d.domain === addon.domain);
                if (addonDomainObj) {
                  if (addonDomainObj.uuid) {
                    addon.uuid = addonDomainObj.uuid;
                  } else {
                    const uuid = uuidv4();
                    addon.uuid = uuid;
                    hasChanges = true;
                    await db.collection('domains').doc(addonDomainObj.id).update({
                      uuid,
                      updatedAt: new Date().toISOString()
                    });
                  }
                }
              }
            }

            if (hasChanges) {
              await docRef.update({
                accounts,
                updatedAt: new Date().toISOString()
              });
            }
          }

          swal('Success', 'You have successfully synchronized site UUIDs.', 'success');
        } catch (error) {
          console.error('Error syncing site UUIDs:', error);
          swal('Error', 'Something went wrong while synchronizing site UUIDs.', 'error');
        } finally {
          this.syncSiteIds = false;
        }
      },
      async syncSiteUuidsOld() {
        console.log('this.doc', this.docID)
        try{
          this.syncSiteIds = true;
          const domainRef = await db.collection('domains').where('uid', '==', this.docID).get();
          if(domainRef.size) {
            const allDomains = []
            domainRef.forEach(el => {
              allDomains.push({id: el.id, ...el.data()});
            })
            const accountRef = await db.collection('hostingAccounts').doc(this.docID).get();
            console.log('data', accountRef.exists)
            if (accountRef.exists) {
              const {accounts} = accountRef.data()
              // const beforePayload = JSON.parse(JSON.stringify(accounts))
              for (const account of accounts) {
                const primaryObj = allDomains.find(el => el.domain === account.primary.domain);
                if (primaryObj) {
                  if (primaryObj.uuid) {
                    console.log('uuid at 634', primaryObj.uuid)
                    account.primary.uuid = primaryObj.uuid;
                  }
                  else {
                    console.log('domain at 638', primaryObj.domain);
                    const uuid = uuidv4();
                    account.primary.uuid = uuid
                    await db.collection('domains').doc(primaryObj.id).update({
                      uuid,
                      updatedAt: new Date().toISOString()
                    })
                  }
                }
                for (const row of account.addon) {
                  const addoObj = allDomains.find(el => el.domain === row.domain);
                  console.log('uuid', addoObj)

                  if (addoObj) {
                    if (addoObj.uuid) {
                      row.uuid = addoObj.uuid;
                    }
                    else {
                      console.log('domain', addoObj.domain);
                      const uuid = uuidv4();
                      row.uuid = uuid
                      await db.collection('domains').doc(addoObj.id).update({uuid, updatedAt: new Date().toISOString()})
                    }
                  }
                }
                console.log('accounts at 663', account.addon)
                // await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: accounts , beforePayload: beforePayload, action: 'Sync Site UUIDs'})
                await db.collection('hostingAccounts').doc(this.docID).update({
                  accounts,
                  updatedAt: new Date().toISOString()
                });
              }
            }
            swal('Success', 'You have successfully synchronized site UUIDs.', 'success')
          }
          if (this.docID === this.showItUID) {
            this.syncSiteUuidsDup()
          }
        } catch (e) {
          console.log('error 630', e.toString())
          swal('Error', 'Something went wrong while synchronizing site uuids.', 'error')
        } finally {
          this.syncSiteIds = false
        }
      },
      async syncSiteUuidsDup() {
        try{
          this.syncSiteIds = true;
          const domainRef = await db.collection('domains').where('uid', '==', `${this.docID}_dup2`).get();
          if(domainRef.size) {
            const allDomains = []
            domainRef.forEach(el => {
              allDomains.push({id: el.id, ...el.data()});
            })
            const accountRef = await db.collection('hostingAccounts').doc(`${this.docID}_dup2`).get();
            console.log('data', accountRef.exists)
            if (accountRef.exists) {
              const {accounts} = accountRef.data()
              // const beforePayload = JSON.parse(JSON.stringify(accounts))
              for (const account of accounts) {
                const primaryObj = allDomains.find(el => el.domain === account.primary.domain);
                if (primaryObj) {
                  if (primaryObj.uuid) {
                    console.log('uuid at 634', primaryObj.uuid)
                    account.primary.uuid = primaryObj.uuid;
                  }
                  else {
                    console.log('domain at 638', primaryObj.domain);
                    const uuid = uuidv4();
                    account.primary.uuid = uuid
                    await db.collection('domains').doc(primaryObj.id).update({
                      uuid,
                      updatedAt: new Date().toISOString()
                    })
                  }
                }
                for (const row of account.addon) {
                  const addoObj = allDomains.find(el => el.domain === row.domain);
                  // console.log('uuid', addoObj)

                  if (addoObj) {
                    if (addoObj.uuid) {
                      row.uuid = addoObj.uuid;
                    }
                    else {
                      // console.log('domain', addoObj.domain);
                      const uuid = uuidv4();
                      row.uuid = uuid
                      await db.collection('domains').doc(addoObj.id).update({uuid, updatedAt: new Date().toISOString()})
                    }
                  }
                }
                // console.log('accounts at 663', account.addon)
                // await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: accounts , beforePayload: beforePayload, action: 'Sync Site UUIDs'})
                await db.collection('hostingAccounts').doc(`${this.docID}_dup2`).update({
                  accounts,
                  updatedAt: new Date().toISOString()
                });
              }
            }
            swal('Success', 'You have successfully synchronized site UUIDs.', 'success')
          }
        } catch (e) {
          console.log('error 630', e.toString())
          swal('Error', 'Something went wrong while synchronizing site uuids.', 'error')
        } finally {
          this.syncSiteIds = false
        }
      },
			terminateEmailService(){
				swal({
					title: "Are you sure?",
					text: `Are you sure to terminate email service for this users?.`,
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(async result => {
						if(result.value){
							this.disableTerminateBtn = true;
							db.collection('users').doc(this.docID).get()
									.then(async doc => {
										await this.$http.post('email/remove-account', {
											grant_type: 'token',
											username:doc.data().emailUsernames.username
										});
										await db.collection("users").doc(this.docID).update({
											emailSetupFlag: false,
											emailUsernames: {},
											allDomians:[],
											emailAccounts:[],
										});
                    await this.fetchUserDetails(this.docID)
										swal({
											text: "Email service has been terminated!",
											type: "success"
										});
                    this.addLog({
                      message: 'Email service has been terminated!',
                      level: 'success'
                    })
										this.disableTerminateBtn = false;
										this.emailSetup = false;
									});
						}
					});
			},
			refreshStorage(){
        const hostingAccounts = this.$store.getters["hosting/accountsOrdered"];
        console.log(hostingAccounts)
				this.spinner = true;
				this.$http.post('disk/space', {
					user_id: this.docID,
          UID: this.docID,
          ip:this.ip,
					grant_type: "token",
					token: this.userToken
				})
					.then(() => {
						swal({
							title: "Success!",
							html: "Disk space updated",
							type: "success"
						});
					})
					.catch((err) => {
						let responseMessage = err.response.data.message;
						if (err.response.status === 422) {
							responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
						}else if(err.response.status === 401 && this.countRequests < 1){
							responseMessage = "You need update token. Please Try Again!";
							this.refreshToken();
						}

						swal({
							title: "Something went wrong!",
							html: "Error update disk space. Message: "+ responseMessage,
							type: "error",
							confirmButtonText: "Try Again!",
							confirmButtonColor: "#EE8057"
						});
						this.addLog({
							name: this.user.firstName + " " + this.user.lastName,
							message: "Error update disk space. Message: " + responseMessage,
							level: "error"
						})
					}).finally(() => {
					this.spinner = false;
				})
			},
			fetchUserDetails(docID) {
				// Check if the admin has actually enter a customer id
				if (docID) {
					// Set asyncDone to false
					this.$store.dispatch("async/stateUpdate", {state: false});

					// Connect to the Firebase Firestore to fetch all the details about the user
					db
						.collection("users")
						.doc(docID)
						.get()
						.then(doc => {
							// Check if the snapshot is empty. if it is empty, then show the admin error asking to recheck the customner id
							// Otherwise fetch the data
							if (!doc.exists) {
								// Set fetchedDetails to false
								this.fetchedDetails = false;

								// Set asyncDone to true
								this.$store.dispatch("async/stateUpdate", {state: true});

								// Show the error to the user for 5 sec
								this.$store.dispatch("alert/update", {
									type: "danger",
									message:
										"No user found for this customer id. Please re-check the customer id to ensure you have entered it correctly or the user has been actually created for this portal.",
									show: true
								});

								setTimeout(() => {
									this.$store.dispatch("alert/showUpdate", {show: false});
								}, 5000);
							} else {
								let fetchedData = doc.data();
								this.$store.dispatch("customer/allDetailsUpdate", {...fetchedData, uid: doc.id, docID: doc.id});

								// Now fetch the hosting account details from the hostingAccounts collection
								this.$store.dispatch('hosting/fetchAccountsAdmin', {UID: docID})
                if(fetchedData.emailSetupFlag){
                  this.emailSetup = true;
                } else {
                  this.emailSetup = false;
                }
								// Fetched details
                this.getAllTasks()
                this.getWatchClientStatus(docID)
								this.fetchedDetails = true
                // this.$store.dispatch("async/stateUpdate", {state: true});


							}
						});
				} else {
					// Show the error in alert message for 5 sec
					this.$store.dispatch("alert/update", {
						type: "danger",
						message: "Please make sure that you have entered a valid customer id",
						show: true
					});

					setTimeout(() => {
						this.$store.dispatch("alert/showUpdate", {show: false});
					}, 5000);
				}
			},
      pendingjobs(docID){
        const query = db.collection('jobLogs')
            .where('jobData.UID', '==', this.docID)
            .where('status', 'in', ['Pending', 'running']);

        this.pendingJobListener =  query.onSnapshot(snapshot => {
          snapshot.docChanges().forEach((change) => {
            const {jobName} = change.doc.data()
            if (change.type === 'added' && (jobName !== 'CHECK-SERVER-CRON' || jobName !== 'CHECK-SERVER-CRON-HOOK')) {
              this.processingDomainList.push({ ...change.doc.data(), id: change.doc.id })
            } else if (change.type === 'removed') {
              this.processingDomainList =  this.processingDomainList.filter(d=> d.id !== change.doc.id)
            }
          })
        });
      },
      async attachDetachListener(docID) {
        this.pendingjobs(docID);
        if(this.accountListener) {
          console.log('Detaching old listener...');
          this.accountListener();
        }
        if(this.dupAccountListener) {
          console.log('Detaching old listener...');
          this.dupAccountListener();
        }
        await this.setupHostingAccountListeners(this.docID);

        // let query = db.collection('hostingAccounts').doc(docID);
        // this.accountListener = query.onSnapshot(() => {
        //   console.log('Changes in this account on admin side. Fetch Fresh Data...');
        //   this.fetchUserDetails(docID)
        // });
        // if (docID === this.showItUID) {
        //   let query1 = db.collection('hostingAccounts').doc(`${docID}_dup2`);
        //   this.dupAccountListener = query1.onSnapshot(() => {
        //     console.log('Changes in this account on admin side. Fetch Fresh Data...');
        //     this.fetchUserDetails(docID)
        //   });
        // }
      },
      async setupHostingAccountListeners(uid) {
        // Clear existing listeners first
        this.clearHostingAccountListeners();

        const docRefs = await getOrderedHostingDocs(uid);

        for (const docRef of docRefs) {
          const unsubscribe = docRef.onSnapshot(() => {
            console.log(`Change detected in ${docRef.id}. Refreshing...`);
            this.fetchUserDetails(uid);
          });

          this.hostingDocListeners.push(unsubscribe);
        }
      },
      clearHostingAccountListeners() {
        this.hostingDocListeners.forEach(unsub => {
          if (typeof unsub === "function") unsub();
        });
        this.hostingDocListeners = [];
      },
      async getCounter (docID) {
        const jobCounterRef = await db.collection('runningJobs').doc(docID).get();
        if (jobCounterRef.exists) {
          const { counter } = jobCounterRef.data();
          this.jobCounter = counter
        } else {
          this.jobCounter = 0
        }
        console.log(this.jobCounter)
      },
      async runAutoSSL () {
				try{
					this.runningSSL = true;
					const userRef = await db.collection('users').doc(this.docID).get();
					if(userRef.data().emailUsernames.username){
						const runSSLResp = await this.$http.post('email/run-auto-ssl', {
							grant_type: 'token',
							username: userRef.data().emailUsernames.username
						});
						console.log(runSSLResp.data);
						if(runSSLResp.data.data){
							swal({
								text: "Auto SSL has been successfully running with process ID: " + runSSLResp.data.data.pid,
								type: "success"
							});
              this.addLog({
                primaryPlan: 'Account Based Operation',
                message: "Auto SSL has been successfully running with process ID: " + runSSLResp.data.data.pid,
                level: 'success'
              })
						}else{
              this.addLog({
                primaryPlan: 'Account Based Operation',
                message: "Auto SSL has been successfully running with process ID: " + runSSLResp.data.metadata.reason,
                level: 'danger'
              })
							swal({
								text: "Auto SSL has been successfully running with process ID: " + runSSLResp.data.metadata.reason,
								type: "error"
							});
						}

					}else{
            this.addLog({
              message: 'Email service is not enabled for this user',
              level: 'danger'
            })
						swal({
							text: "Email service is not enabled for this user",
							type: "error"
						});
					}
					this.runningSSL = false;
				}catch (e) {
					this.runningSSL = false;
					console.error(e);
          this.addLog({
            message: "There is an error in running auto-ssl api. Please make sure that email service is enabled.",
            level: 'danger'
          })
					swal({
						text: "There is an error in running auto-ssl api. Please make sure that email service is enabled.",
						type: "error"
					});
				}
			}
		},
		created() {
      this.$store.commit('hosting/setDocID', this.docID)
			this.attachDetachListener(this.docID)
		},
    beforeDestroy() {
      this.clearHostingAccountListeners();
    },
    destroyed() {
			console.log('Detach account listener on admin side...');
      if (this.accountListener) {
        this.accountListener();
      }
      if (this.dupAccountListener) {
        this.dupAccountListener();
      }
      // if (this.counterListener) {
      //   this.counterListener();
      // }
      if (this.pendingJobListener) {
        this.pendingJobListener();
      }
      this.$store.commit('hosting/loadAccountsMutate', {accounts: []})
      this.$store.commit('hosting/loadAccountsWithOrderMutate', {accounts: []})
		}
	};
</script>

<style >
	.login-as-user {
		/*position: absolute;*/
		/*right: 50px;*/
		/*top: 85px;*/
	}
	.refresh-storage{
		/*position: absolute;*/
		/*right: 100px;*/
		/*top: 85px;*/
	}
	.small_btn_loader{
		margin: 0 auto !important;
		width: 15px !important;
		height: 15px !important;
	}
  a{
    &.dropdown-item{
      &.disabled {
        pointer-events: none;
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
</style>

<style scoped>
.filter-btn, .filter-btn:active, .filter-btn:focus {
  background-color: transparent!important;
  color: black!important;
}
.filter-btn:hover {
  background-color: black !important;
  color: white !important;
}
.dropdown-menu{
  transform: translate3d(-85px, 28px, 0px) !important;
}
</style>

